import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export const ResendReceipt = () => {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);

  const send = async (e) => {
    e.preventDefault();
    setBusy(true);
    setMsg(null);
    try {
      const { data } = await api.post("/payments/resend-receipt", { email: email.trim() });
      setMsg({ ok: true, text: data.message });
    } catch (err) {
      setMsg({ ok: false, text: errMsg(err, "Could not resend receipt") });
      if (err?.response?.status === 422) toast.error("Please enter a valid email");
    } finally {
      setBusy(false);
    }
  };

  if (!open) {
    return <button type="button" onClick={() => setOpen(true)} className="text-sm text-mm-muted hover:text-mm-primary underline-offset-2 hover:underline" data-testid="resend-receipt-link">Lost your receipt?</button>;
  }
  return (
    <form onSubmit={send} className="mm-soft p-4 mt-2 text-left" data-testid="resend-receipt-form">
      <div className="text-sm font-semibold">Resend my receipt</div>
      <p className="text-xs text-mm-muted mt-0.5">Enter the email you paid with. We'll resend the receipt with your sign-up link.</p>
      <div className="flex gap-2 mt-3">
        <input type="email" required className="mm-input !py-2" placeholder="you@example.com" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="resend-receipt-email" />
        <button className="mm-btn !px-4 !py-2" disabled={busy} data-testid="resend-receipt-submit">{busy ? <Loader2 size={16} className="animate-spin" /> : "Send"}</button>
      </div>
      {msg && <p className={`text-sm mt-2 ${msg.ok ? "text-mm-success" : "text-mm-error"}`} data-testid="resend-receipt-message">{msg.text}</p>}
    </form>
  );
};
